<template>
    <div class="view-TeachingStatistics">
        <HeaderSelect :schoolList="schoolList" @handleStatistics="handleStatistics"></HeaderSelect>
        <el-tabs v-model="activeName" stretch @tab-click="handleClick">
            <el-tab-pane label="总量统计" name="total">
              <TotalStatistics @linkTo="linkTo" :tableData="tableData"></TotalStatistics>
            </el-tab-pane>
            <el-tab-pane label="班级课程" name="class">
                <span slot="label"> 专业/班级：
                  <!-- 班级课程： -->
                    <span :class="{ num: !(activeName === 'second') }">
                        {{ totalCount.albumCount }} 
                    </span>
                </span>
                <ClassStatistics ref="class" :listType="activeName" :isReflesh.sync="isReflesh" :forms="form" :isReset.sync="isReset"></ClassStatistics>
            </el-tab-pane>
            <el-tab-pane label="点播课程" name="dibble">
                <span slot="label"> 点播课程/资源：
                    <span :class="{ num: !(activeName === 'third') }">
                        {{ totalCount.courseCount }}
                    </span>
                </span>
                <DibbleStatistics ref="dibble" :forms="form" :listType="activeName" :isReflesh.sync="isReflesh" :isReset.sync="isReset"></DibbleStatistics>
            </el-tab-pane>
            <el-tab-pane label="直播课程" name="live">
                <span slot="label">直播课程：
                    <span :class="{ num: !(activeName === 'fourth') }">
                        {{ totalCount.liveCourseCount }}
                    </span>
                </span>
                <!-- <LiveStatistics></LiveStatistics> -->
            </el-tab-pane>
            <el-tab-pane label="面授课程" name="face">
                <span slot="label"> 面授课程：
                    <span :class="{ num: !(activeName === 'fifth') }">
                        {{ totalCount.teacherCourseCount }}
                    </span>
                </span>
                <!-- <FaceStatistics></FaceStatistics> -->
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import HeaderSelect from "./component/HeaderSelect.vue";
import TotalStatistics from "./component/TotalStatistics/TotalStatistics.vue";
import ClassStatistics from "./component/ClassStatistics/ClassStatistics.vue";
import DibbleStatistics from "./component/dibbleStatistics/dibbleStatistics.vue";
// import LiveStatistics from "./component/LiveStatistics/LiveStatistics.vue";
// import FaceStatistics from "./component/FaceStatistics/FaceStatistics.vue";
import {
  getTotalList,
  getSchoolList,
  getTotalCount,
  getTotalCounts,
  getAlbumTotalCount
} from "@/api/TeachingStatistics";
export default {
    data() {
      return {
        // 选项卡
        activeName: "total",
        schoolList: [],
        tableData: [],
        totalCount: {},
        isReset:false,
        form:{},
        isReflesh: false,
        totalCountItem:{}
      };
    },
    components: {
      HeaderSelect,
      TotalStatistics,
      // LiveStatistics,
      DibbleStatistics,
      // FaceStatistics,
      ClassStatistics,
    },
    methods: {
      async init() {
          Promise.all([
              getSchoolList(),
              getTotalCount(),
              getTotalList(),
          ]).then(([school, totalCount, totalList]) => {
              this.schoolList = school.data.data;
              this.totalCount = totalCount.data.data;
              this.tableData = totalList.data.data;
          });
      },
      linkTo(i) {
          this.activeName = i;
      },
      // 标签页切换
      async handleClick() {
          if (this.activeName === "total") {
          }
          if (this.activeName === "class") {
            this.isReset = true;
            this.$refs.class.handleClick();
            // const {data} = await getAlbumTotalCount(this.form)
            // if(data.code === 100000){
            //   this.totalCountItem = data.data;
            // }
          }
          if (this.activeName === "dibble") {
            this.isReset = true;
            this.$refs.dibble.handleClick();
            console.log('我是切换')
          }
          if (this.activeName === "live") {
          }
          if (this.activeName === "face") {
          }
      },
      /** 开始统计事件 */
      handleStatistics(form){
        this.form = form;
        this.isReflesh = true;
        Promise.all([
          getTotalCounts(form),
          getTotalList(form),
        ]).then(([totalCount, totalList]) => {
            this.totalCount = totalCount.data.data;
            this.tableData = totalList.data.data;
            this.handleClick();
        });
      }
    },
    created() {
        this.init();
    },
};
</script>

<style lang="scss" scoped>
.el-tab-pane {
    font-size: 24px;
}
.num {
    font-size: 24px;
    font-weight: 700;
    color: red;
}
.num:hover {
    color: #409eff;
}
/deep/.el-tabs__item {
    font-size: 24px;
}
/deep/.is-active {
    background-color: #64b0ff;
    border-radius: 5px 5px 0 0;
    color: #fff;
}
/deep/.el-tabs__header {
    margin: 0;
}
.view-TeachingStatistics{
  padding-top: 20px;
}
</style>